import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DetectorController, { CounponListType } from '../../controller/DetectorController';
import 'moment/locale/ko';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Loading from '../../components/Loading';

type tabType = {
  id: number;
  title: string;
  type: string;
};
type HotelSelectType = {
  name: string;
  store_id: number;
  user_id: number;
};
const typeTabContent: tabType[] = [
  {
    id: 0,
    title: '온보딩',
    type: 'onboarding',
  },
  {
    id: 1,
    title: '테스트 주문',
    type: 'normal',
  },
  {
    id: 2,
    title: '쿠폰만 발급하기',
    type: 'null',
  },
];

const TestOrder = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>('');
  const [tabType, setTabType] = useState<string>('');
  const [storeList, setStoreList] = useState<HotelSelectType[]>([]);
  const [searchStoreList, setSearchStoreList] = useState<HotelSelectType[]>([]);
  const [selectStore, setSelectStore] = useState<number[]>([]);
  const [couponList, setCouponList] = useState<CounponListType[]>([]);
  const [selectedCoupon, setSelectedCoupon] = useState<number | null>(null);

  // 매장 선택
  const handleCheckboxChange = (userId: number) => {
    setSelectStore((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId],
    );
  };
  // 매장 검색
  const handleSearch = () => {
    const filtered = searchStoreList.filter((store) =>
      store.name.toLowerCase().includes(keyword.toLowerCase()),
    );
    setStoreList(filtered);
  };

  // 매장 검색
  const getStoreByName = async () => {
    try {
      const oData = {
        store_name: keyword,
      };
      setIsLoading(true);
      const response = await DetectorController.getStoreByName(oData);

      if (response && response.data) {
        const storefilteredData = response.data.data.filter((item: any) => item.store_type === 1);
        const formattedStoreList = storefilteredData.map((item: any) => ({
          name: item.store_name,
          store_id: item.store_id,
          user_id: item.user_id,
        }));
        setSearchStoreList(formattedStoreList);
        setStoreList(formattedStoreList);
      }
    } catch (err) {
      console.log('getStoreByName err-->', err);
    } finally {
      setIsLoading(false);
    }
  };
  // 쿠폰검색
  const getCouponList = async () => {
    try {
      setIsLoading(true);
      const response = await DetectorController.getTemplate();

      if (response && response.data.ok) {
        setCouponList(response.data.data);
      }
    } catch (err) {
      console.log('getCouponList err-->', err);
    }
  };
  // 테스트주문하기
  const testOrderAndCoupon = async () => {
    try {
      if (tabType === '') {
        toast.error('테스트 주문 유형을 선택해주세요.');
      } else if (selectStore.length === 0) {
        toast.error('매장을 선택해주세요.');
      } else if (tabType === 'null' && selectedCoupon === null) {
        toast.error('쿠폰만 발급하기를 선택하셨습니다.쿠폰을 선택해주세요.');
      } else {
        const oData = {
          store_ids: selectStore,
          test_order_type: tabType,
          coupon_template_id: selectedCoupon,
        };
        const response = await DetectorController.testOrderAndCoupon(oData);

        if (response && response.data.ok) {
          toast.success('테스트 주문 및 쿠폰발급이 완료되었습니다.');
          setTabType('');
          setSelectStore([]);
          setSelectedCoupon(null);
        }
      }
    } catch (err) {
      toast.error('다시 시도해주세요.');
      console.log('getCouponList err-->', err);
    }
  };

  useEffect(() => {
    setKeyword('');
    getStoreByName();
    getCouponList();
  }, []);
  console.log('selectedCoupon -->', selectedCoupon);
  return (
    <Style>
      <div className="rightContentWrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h1>테스트 주문 및 쿠폰 발급</h1>
        {isLoading ? (
          <div className="loadingWrap">
            <Loading />
          </div>
        ) : (
          <div className="posTestContent">
            <h2>테스트 주문 유형 선택</h2>
            <div className="tabWrap">
              {typeTabContent.map((data, index) => (
                <label key={index}>
                  <input
                    type="radio"
                    name="tabType"
                    value={data.id}
                    checked={tabType === data.type}
                    onChange={() => setTabType(data.type)}
                    className="radioInput"
                  />
                  <span className="text-sm">{data.title}</span>
                </label>
              ))}
            </div>
            <h2>매장 선택</h2>
            <div className="searchWrap rowCenter">
              <input
                className="searchInput"
                value={keyword}
                placeholder="매장명을 검색해주세요"
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch();
                  }
                }}
              />
              <button onClick={() => handleSearch()}>검색하기</button>
            </div>
            <div className="storeListWrap rowCenter">
              {storeList.map((data, index) => (
                <label className="storeContent" key={index}>
                  <input
                    type="checkbox"
                    value={data.store_id}
                    checked={selectStore.includes(data.store_id)}
                    onChange={() => handleCheckboxChange(data.store_id)}
                  />
                  <span>{data.name}</span>
                </label>
              ))}
            </div>
            <h2>쿠폰선택</h2>
            <div className="couponListWrap">
              {couponList.map((data) => (
                <label className="couponList" key={data.id}>
                  <input
                    type="radio"
                    name="coupon"
                    value={data.name}
                    checked={selectedCoupon === data.id}
                    onClick={() => {
                      if (selectedCoupon === data.id) {
                        setSelectedCoupon(null);
                      }
                    }}
                    onChange={() => setSelectedCoupon(data.id)}
                  />
                  <div className="couponInfo">
                    <h3>쿠폰명: {data.name}</h3>
                    <h3>쿠폰설명: {data.description}</h3>
                    <h4>쿠폰 금액 {data.price.toLocaleString()}원</h4>
                    <h4>최소 주문 금액 {data.min_order_price.toLocaleString()}원</h4>
                    <h4>수량 {data.issue_limit_count.toLocaleString()}장</h4>
                  </div>
                </label>
              ))}
            </div>
            <button onClick={testOrderAndCoupon} className="submitBtn">
              테스트 주문 및 쿠폰 발급하기
            </button>
          </div>
        )}
      </div>
    </Style>
  );
};

export default TestOrder;

const Style = styled.div`
  /* 공통 */
  h1 {
    font-size: 24px;
  }
  h2 {
    margin-top: 50px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 400;
    color: #555;
    background: #4dd2ae;
    color: #fff;
    display: inline-block;
    padding: 6px 12px 4px 12px;
  }
  h3 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  h4 {
    font-size: 14px;
    font-weight: 500;
    color: #555;
  }
  .rowCenter {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rightContentWrap {
    min-width: 100%;
    width: fit-content;
    min-height: 100vh;
    background: #ffffff;
    padding: 2%;
  }

  /* loadingWrap */
  .loadingWrap {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* tabWrap */
  .tabWrap {
    display: flex;
    gap: 4%;

    input {
      margin-right: 4px;
    }
  }

  /* searchWrap */
  .searchWrap {
    width: 50%;
    align-items: flex-end;

    .searchInput {
      width: 100%;
      padding: 4px;
      border: none;
      border-bottom: 1px solid #ccc;
      font-size: 18px;
      outline: none;
    }
    button {
      padding: 10px 16px;
      white-space: nowrap;
      background: #000;
      color: #fff;
      border-radius: 4px;
      border: none;
    }
  }

  /* storeListWrap */
  .storeListWrap {
    margin-top: 16px;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-height: 490px;
    padding: 10px 16px;
    overflow-y: scroll;
    border: 1px solid #eee;
    border-radius: 4px;

    .storeContent {
      width: 25%;
      margin: 10px 0;
    }
  }

  /* couponListWrap */
  .couponListWrap {
    display: flex;
    gap: 12px;
    margin-top: 12px;
    flex-wrap: wrap;

    .couponList {
      flex-direction: column;
      align-items: flex-start;
      border: 1px solid #eee;
      padding: 12px;
      border-radius: 4px;

      h3,
      h4 {
        margin: 3px 0;
        word-break: keep-all;
      }
      .couponInfo {
        padding: 6px 8px;
      }
    }
  }

  /* submitBtn */
  .submitBtn {
    width: 100%;
    margin: 60px 0 30px 0;
    padding: 16px 0;
    background: #000;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 6px;
    font-size: 18px;
  }

  /* input 공통 */
  label {
    display: flex;
    gap: 6px;
    cursor: pointer;
  }
  .radioInput {
    width: 18px;
    height: 18px;
  }
  input {
    accent-color: green;
  }

  @media (max-width: 1000px) {
    .searchWrap {
      width: 100%;
    }
    .storeListWrap {
      width: 100%;

      .storeContent {
        width: 50%;
      }
    }
    .couponListWrap {
      .couponList {
        width: 100%;
      }
    }
  }
`;
